"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _actions = require("./actions");
var _oneWeir = require("@weirgroup/one-weir");
var _mainModule = _interopRequireDefault(require("./main.module.css"));
class Navigation extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onMenuClick = this.onMenuClick.bind(this);
  }
  componentDidMount() {
    if (this.props !== undefined) {
      if (this.props.appName !== undefined) {
        window.localStorage.setItem('appName', this.props.appName);
      }
      if (this.props.applicationID !== undefined) {
        window.localStorage.setItem('appID', this.props.applicationID);
        this.props.dispatch(_actions.navigationActions.getNavigation(this.props.applicationID, this.props.appName));
      }
    }
  }
  renderNavItem(navItem, index) {
    return /*#__PURE__*/_react.default.createElement(_oneWeir.NavItem, {
      "data-test": 'tab' + index,
      selected: window.location.pathname === navItem.link || window.location.pathname === "".concat(navItem.link, "/"),
      key: navItem.name,
      onClick: () => {
        this.onMenuClick(navItem, index);
      }
    }, navItem.name);
  }
  onMenuClick(navItem, index) {
    const action = _actions.navigationActions.onInAppSelectionChange(navItem, this.props.history);
    this.props.dispatch(action);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.wrapper
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.Navbar, null, this.props.menuItems ? this.props.menuItems.map((navItem, index) => this.renderNavItem(navItem, index)) : ''));
  }
}
function mapStateToProps(state) {
  if (state.inAppMenu !== undefined) {
    const {
      menuItems,
      selectedMenu
    } = state.inAppMenu;
    return {
      menuItems,
      selectedMenu
    };
  }
}

// any props you need else

const connectedNavigation = exports.Navigation = (0, _reactRedux.connect)(mapStateToProps)(Navigation);